export class DataUtil {
  public static IsoStringTime: RegExp = /\d{4}(.\d{2}){2}(\s|T)(\d{2}.){2}\d{2}/g;
  public static JustNumberRegex: RegExp = /^[0-9]*$/;

  static store: Map<HTMLElement, Map<string, unknown>> = new Map()

  public static set(instance: HTMLElement | undefined, key: string, data: unknown): void {
    if (!instance) {
      return
    }

    const instanceData = DataUtil.store.get(instance)
    if (!instanceData) {
      const newMap = new Map().set(key, data)
      DataUtil.store.set(instance, newMap)
      return
    }

    instanceData.set(key, data)
  }

  public static get(instance: HTMLElement, key: string): unknown | undefined {
    const instanceData = DataUtil.store.get(instance)
    if (!instanceData) {
      return
    }

    return instanceData.get(key)
  }

  public static remove(instance: HTMLElement, key: string): void {
    const instanceData = DataUtil.store.get(instance)
    if (!instanceData) {
      return
    }

    instanceData.delete(key)
  }

  public static removeOne(instance: HTMLElement, key: string, eventId: string) {
    const instanceData = DataUtil.store.get(instance)
    if (!instanceData) {
      return
    }

    const eventsIds = instanceData.get(key)
    if (!eventsIds) {
      return
    }

    const updateEventsIds = (eventsIds as string[]).filter((f) => f !== eventId)
    DataUtil.set(instance, key, updateEventsIds)
  }

  public static has(instance: HTMLElement, key: string): boolean {
    const instanceData = DataUtil.store.get(instance)
    if (instanceData) {
      return instanceData.has(key)
    }

    return false
  }

  public static getAllInstancesByKey(key: string) {
    const result: any[] = []
    DataUtil.store.forEach((val) => {
      val.forEach((v, k) => {
        if (k === key) {
          result.push(v)
        }
      })
    })
    return result
  }

  public static currencyFormatter(currency: number) {
    var sansDec = currency?.toFixed(0);
    var formatted = sansDec?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${formatted}`;
  }

  public static IsNumeric(input: string) {
    let temp = this.PersianDigitToEnglish(input);
    return /^[0-9]+$/.test(temp);
  }

  public static PersianDigitToEnglish(input: string) {
    let persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ];
    let arabicNumbers = [
      /٠/g,
      /١/g,
      /٢/g,
      /٣/g,
      /٤/g,
      /٥/g,
      /٦/g,
      /٧/g,
      /٨/g,
      /٩/g,
    ];
    if (typeof input === 'string') {
      for (var i = 0; i < 10; i++) {
        input = input
          .replace(persianNumbers[i], i.toString())
          .replace(arabicNumbers[i], i.toString());
      }
    }
    return input;
  }

  public static toIsoString(value: string, haveTime: boolean = false) {
    let date = new Date(value);
    if (!haveTime) date.setHours(0, 0, 0, 0);
    var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function (num: any) {
        return (num < 10 ? '0' : '') + num;
      };

    return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      '.' + pad(date.getMilliseconds()) +
      dif + pad(Math.floor(Math.abs(tzo) / 60)) +
      ':' + pad(Math.abs(tzo) % 60);
  }

  public static ChangeCharacterToOtherCharacter(value: string, main: string, replace: string) {
    return value.toString().split(main).join(replace);
  }

  public static ConvertDate(value: any) {
    const regexISOStringTime = new RegExp(this.IsoStringTime);
    const regexJustNumber = new RegExp(this.JustNumberRegex);
    if (regexISOStringTime.test(value)) {
      return value;
    }

    if (!isNaN(value) && regexJustNumber.test(value)) {
      let tempValue: number = value.length === 10 ? value * 1000 : value;
      let convertedValueToISOString = new Date(tempValue).toISOString();
      return convertedValueToISOString;
    }
    return null;
  }

  public static ConvertDateToPersianDate(value: any, args?: any) {
    let option: Object = new Object();
    if (args === 'date') {
      option = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      };
    }

    if (args === 'date-string') {
      option = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
      };
    }

    if (args === 'time') {
      return new Date(value).toTimeString().split(' ')[0];
    }
    if (Object.keys(option).length > 0) {
      return new Date(value).toLocaleDateString('fa-IR', option!);
    } else {
      let fullDate = new Date(value).toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
      });
      let fullTime = new Date(value).toTimeString().split(' ')[0];
      let fullTimeArray: string[] = fullTime.split(':');
      return `${fullDate} ${fullTimeArray[0]}:${fullTimeArray[1]}`;
    }
  }


  public static ConvertDateToObject(date: string, separator: string = '-'): { miladi: string, shamsi: string } {
    let tempShamsi = new Date(date).toLocaleDateString('fa-IR');
    let modifiedString = tempShamsi.replace(/\//g, '-');
    let separateShamsi = modifiedString.toString().split('-');
    const yearShamsi = Number(this.PersianDigitToEnglish(separateShamsi[0]));
    const monthShamsi = separateShamsi[1].toString().length === 1 ? ('0' + Number(this.PersianDigitToEnglish(separateShamsi[1]))) : Number(this.PersianDigitToEnglish(separateShamsi[1]));
    const dayShamsi = separateShamsi[2].toString().length === 1 ? ('0' + Number(this.PersianDigitToEnglish(separateShamsi[2]))) : Number(this.PersianDigitToEnglish(separateShamsi[2]));
    const shamsi = `${yearShamsi}${separator}${monthShamsi}${separator}${dayShamsi}`;

    let tempMiladi = new Date(date);

    const yearMiladi = tempMiladi.getFullYear();
    const monthMiladi = tempMiladi.getMonth().toString().length === 1 ? ('0' + (tempMiladi.getMonth() + 1)) : (tempMiladi.getMonth() + 1);
    const dayMiladi = tempMiladi.getDate().toString().length === 1 ? ('0' + tempMiladi.getDate()) : tempMiladi.getDate();
    const miladi = `${yearMiladi}${separator}${monthMiladi}${separator}${dayMiladi}`;
    return { miladi: miladi, shamsi: shamsi }
  }

  // توابعی برای محاسبه اختلاف تاریخ‌ها و اعلام خطا
  public static dateDiffInDays(date1: Date, date2: Date): number {
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  public static compareDates(date1: Date, date2: Date, dayLength: number = 31): boolean {
    const daysDifference = this.dateDiffInDays(date1, date2);
    return daysDifference > dayLength;
  }

  public static futureMonthDate(count: number): Date {
    let today = new Date();
    let futureDate = new Date(today.getFullYear(), today.getMonth() + count, today.getDate());

    // چک کردن آیا تاریخ به سررسید رسیده و نیاز به تغییر سال دارد یا خیر
    if (futureDate.getMonth() !== today.getMonth() + 1) {
      futureDate = new Date(today.getFullYear() + 1, 0, today.getDate());
    }
    return futureDate;
  }

  public static CompareFromDateWithToDate(fromDate: string, toDate: string): boolean {
    const departureDate = new Date(fromDate).getTime();
    const returnDate = new Date(toDate).getTime();
    return returnDate >= departureDate ? true : false;
  }

  public static removeLeadingZeros(value: string) {
    return value.replace(/^0+/, '');
  }

  public static CalculateHeight() {
    const ds_app_header = document.getElementById('ds_app_header')?.clientHeight;
    const ds_app_toolbar = document.getElementById('ds_app_toolbar')?.clientHeight;
    const ds_app_footer = document.getElementById('ds_app_toolbar')?.clientHeight;
    const ds_app_card_header_toolbar = document.getElementById('ds_app_card_header_toolbar')?.clientHeight;
    const ds_app_body = document.getElementById('ds_app_body')?.clientHeight;
    const sizes: number = [ds_app_header!, ds_app_toolbar!, ds_app_card_header_toolbar!, ds_app_footer!].reduce((a, b) => a + b, 0);
    return ds_app_body! - sizes - 55;
  }
}
